module.exports = __webpack_public_path__ + "static/media/riskyActivityQuestion.d159de80.mp3";